export default "/318e1506d99481ce782509087d9dda7f.jpg";